// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { globalNotificationBarStyles } from "@steiner/App/Widgets/Common/GlobalNotificationBar";
import { fontConfig } from "@steiner/XDL/PreStyle/typography";
import { color, layoutContainer, xScreen } from "@steiner/XDL/Utilities";
import { css } from "styled-components";

globalNotificationBarStyles.wrapper = {
    css: css`
        padding-top: 4px;
        padding-bottom: 4px;

        ${({ bgColor }: any) => {
            return css`
                background-color: ${bgColor};
            `;
        }}
    `,
};

globalNotificationBarStyles.container = {
    css: css`
        display: flex;
        align-items: center;
        justify-content: center;
        position: relative;
        ${layoutContainer};
    `,
};

globalNotificationBarStyles.message = {
    variant: "h6",
    weight: fontConfig.weight.regular,
    css: css`
        text-align: center;
        margin-bottom: 0;

        ${xScreen("lte", "md")} {
            padding-left: 16px;
            padding-right: 16px;
        }
    `,
};

globalNotificationBarStyles.closeIcon = {
    size: 12,
    color: "common.ui1",
    css: css`
        position: absolute;
        right: 16px;
        top: 50%;
        transform: translateY(-50%);
        cursor: pointer;

        &:hover {
            color: ${color("common.ui9")};
        }

        ${xScreen("lte", "sm")} {
            top: 8px;
            right: 8px;
        }
    `,
};
